import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "types";
import { initialState } from "./initialState";

const selectDomain = (state: RootState) =>
  state.frontClearanceState || initialState;

export const selectFrontClearanceManufacturerFilter = createSelector(
  [selectDomain],
  (frontClearanceState) => frontClearanceState.manufacturerFilter
);

export const selectFrontClearanceMasterModelFilter = createSelector(
  [selectDomain],
  (frontClearanceState) => frontClearanceState.masterModelFilter
);

export const selectFrontClearanceYearFilter = createSelector(
  [selectDomain],
  (frontClearanceState) => frontClearanceState.yearFilter
);

export const selectFrontClearanceLoading = createSelector(
  [selectDomain],
  (frontClearanceState) => frontClearanceState.loading
);

export const selectFrontClearanceList = createSelector(
  [selectDomain],
  (frontClearanceState) => frontClearanceState.list
);

export const selectFrontClearanceMeta = createSelector(
  [selectDomain],
  (frontClearanceState) => frontClearanceState.meta
);

export const selectFrontClearancePage = createSelector(
  [selectDomain],
  (frontClearanceState) => frontClearanceState.page
);

export const selectFrontClearancePerPage = createSelector(
  [selectDomain],
  (frontClearanceState) => frontClearanceState.perPage
);

export const selectIsAddModalOpen = createSelector(
  [selectDomain],
  (frontClearanceState) => frontClearanceState.isAddModalOpen
);

export const selectFrontClearanceForm = createSelector(
  [selectDomain],
  (frontClearanceState) => frontClearanceState.form
);

export const selectFrontClearanceSaving = createSelector(
  [selectDomain],
  (frontClearanceState) => frontClearanceState.saving
);
